var global = typeof window === 'undefined' ? this || {} : window;
export { global };
